import { useEffect, useState } from "react";

import { useAuth } from "@/src/auth/hooks/useAuth";

export interface ServerTime {
  currentTime: number;
}

export const useGetServerTime = (): ServerTime => {
  const { serverTimeDiffMs } = useAuth();
  const [currentTime, setCurrentTime] = useState(Date.now() + serverTimeDiffMs);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now() + serverTimeDiffMs);
    }, 1000);
    return () => clearInterval(interval);
  }, [serverTimeDiffMs]);

  return { currentTime };
};
